import React, {Fragment} from "react";
import {S360_urls} from "root/s360components/constants/S360_constants";
import S360Link from "root/s360components/S360Link";
import {useAdminUsersDashboardContext} from "root/s360components/AdminUsersDashboardContext";

const ConcernReportDashboardLink = () =>
{
    /*
    const [data, setData] = useState({ isLoading: true, data: [] });

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        if(school_id !== undefined)
        {
            getActiveConcernReportsForSChool(school_id, (response) =>
            {
                setData({isLoading: false, data: getDataFromResponse(response)});
            });
        }
    };

     */

    const checkFlashIcon = (data) =>{
        let flash_icon = false;

        if(data.active_concern_report.length > 0){
            flash_icon = true;
        }

        return flash_icon;
    }

    const {isLoading, data} = useAdminUsersDashboardContext();

    return (
        <Fragment>
            <S360Link url={S360_urls.CONCERN_REPORTS_URL} title='Concern Reports' icon='glyphicon glyphicon-warning-sign' flashBg={() => checkFlashIcon(data)}/>
        </Fragment>

    )
}

export default ConcernReportDashboardLink;